module.exports = __webpack_public_path__ + "static/media/02.a47616f7.jpg";